<template>
  <div class="after-sale-detail">
    <div class="page-header">
      <i class="iconfont icon-back" @click="goBack">&#xe615;</i>
      <div class="page-title">售后详情</div>
      <i class="iconfont"></i>
    </div>

    <!-- 售后状态 -->
    <!-- TODO: 没做完。看小程序，条件渲染 -->
    <div class="after-sale-status">
      <div class="status">
        <i class="iconfont">&#xe601;</i>
        <span class="label">{{ afterSaleInfo.rma_status }}</span>
      </div>

      <div class="description" v-if="afterSalesFlow.auditCompleted && afterSalesFlow.auditCompleted.description">
        <span> {{ afterSalesFlow.auditCompleted.description }}</span>
        <a
          target="_blank"
          v-if="['AFTERSALE_REFUSED','AFTERSALE_CLOSED'].includes(afterSaleInfo.rma_status_code)"
          class="udesk-go-service"
          >在线客服</a
        >
      </div>
      <div v-else-if="afterSalesFlow.currentFlow.description" class="description">
        <span>{{ afterSalesFlow.currentFlow.description }}</span>
      </div>
    </div>
    <div class="after-sales-process" v-if="noProcessStatus">
      <div class="bg-line"></div>
      <div
        class="process-line"
        :style="`width: ${afterSalesFlow.currentFlow.width}`"
      ></div>

      <div
        v-for="(item, index) in afterSalesFlow.flowList"
        :key="index"
        :class="[
          'level-item',
          index < afterSalesFlow.currentFlow.key ? 'level-item-active' : '',
          index === afterSalesFlow.currentFlow.key - 1 ? 'current-item' : '',
        ]"
        :style="
          'left:' + (100 / (afterSalesFlow.flowList.length - 1)) * index + '%'
        "
      >
        <div
          v-if="afterSalesFlow.currentFlow.key - 1 !== index"
          class="level-item-icon"
        ></div>
        <span v-else class="iconfont-ot-website">&#xe6e0;</span>
        <div class="level-item-name">{{ item.label }}</div>
      </div>
    </div>
    <!-- 退货信息 -->
    <div class="after-sale-list">
      <div class="after-sale-title">退货信息</div>
      <div class="after-sale-content">
        <div class="content-title">商品</div>
        <div class="content">
          <div
            class="goods-items"
            v-for="(item, index) in afterSaleInfo.goods"
            :key="index"
          >
            <div class="goods-items-content">
              <div class="item-img">
                <div @click="goDetail(item)">
                  <img :src="item.cover" alt class="goods-pic" />
                  <span class="after-sale-status-babel">{{
                    item.status
                  }}</span>
                </div>
              </div>
              <div class="goods-right">
                <div class="goods-info">
                  <div @click="goDetail(item)" class="goods-name">
                    {{ item.name }}
                  </div>
                  <div class="goods-size">
                    <div style="margin-right: 30px">
                      颜色：{{ item.color.name }}
                    </div>
                    <div>尺码：{{ item.size }}</div>
                  </div>
                  <ProductLabel :product-label="item.product_label" />
                  <p class="markdown-tip is-desktop" v-if="item.is_mark_down">
                    <span class="iconfont-ot-website">&#xe60f;</span>
                    <span>折扣商品不可与其他活动同时享受折扣</span>
                  </p>
                </div>
                <div class="goods-others">
                  <div class="num">x{{ item.quantity }}</div>
                  <div class="price">
                    <p
                      class="item-original_price"
                      v-if="isShowOriginalPrice(item)"
                    >
                      <span class="rmb-symbol">￥</span
                      >{{ (item.original_price || 0) | filterPrice }}
                    </p>
                    <p><span class="rmb-symbol">￥</span>{{ item.price }}</p>
                  </div>
                </div>
              </div>
            </div>
            <p class="markdown-tip is-mobile" v-if="item.is_mark_down">
              <span class="iconfont-ot-website">&#xe60f;</span>
              <span>折扣商品不可与其他活动同时享受折扣</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 订单摘要 -->
    <div class="after-sale-others">
      <div class="total">
        <div class="tit">售后类型：</div>
        <div class="num">
          <span>{{ afterSaleInfo.chargeback_type }}</span>
        </div>
      </div>
      <div class="total">
        <div class="tit">退款金额：</div>
        <div class="num">
          <span class="rmb-symbol">￥</span>
          <span>{{ afterSaleInfo.refund_total_amount }}</span>
        </div>
      </div>
      <div class="total">
        <div class="tit">退回积分：</div>
        <div class="num">
          <span>{{ afterSaleInfo.refund_points_deducted }}积分</span>
        </div>
      </div>
      <div class="total">
        <div class="tit">退回方式：</div>
        <div class="num">
          <span>原路退回</span>
        </div>
      </div>
      <div class="total" v-if="afterSaleInfo.chargeback_type_code === 1">
        <div class="tit">物流类型：</div>
        <div class="num">
          <span>{{ afterSaleInfo.delivery_type }}</span>
        </div>
      </div>
      <div class="total" v-if="afterSaleInfo.chargeback_type_code === 1">
        <div class="tit">物流单号：</div>
        <div class="num">
          <span>{{ afterSaleInfo.logistics_no }}</span>
          <span
            class="iconfont-ot-website icon-copy"
            @click="copyText(afterSaleInfo.logistics_no)"
            >&#xe606;</span
          >
        </div>
      </div>
      <div class="total">
        <div class="tit">退货原因：</div>
        <div class="num">
          {{ chargebackReasons }}
        </div>
      </div>
      <div class="total">
        <div class="tit">申请时间：</div>
        <div class="num">
          <span>{{ afterSaleInfo.created_at }}</span>
        </div>
      </div>
      <div class="total">
        <div class="tit">订单编号：</div>
        <div class="num">
          <span>{{ afterSaleInfo.order_no }}</span>
          <span
            class="iconfont-ot-website icon-copy"
            @click="copyText(afterSaleInfo.order_no)"
            >&#xe606;</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils";
import ProductLabel from "@/components/ProductLabel.vue";
import { captureManualError } from "@/sentry/index";
import utilsOrder from "@/utils/order";

export default {
  components: { ProductLabel },

  data() {
    return {
      afterSaleInfo: {},
      afterSalesFlow: {
        currentFlow: {},
        flowList: [],
        auditCompleted: {},
      },
    };
  },
  created() {
    if (this.$route.query.rma_id) {
      this.getRmaDetail();
    } else {
      this.$router.replace({ path: "/myaccount/orders" });
    }
  },
  methods: {
    isShowOriginalPrice: utils.isShowOriginalPrice,
    getRmaDetail() {
      api[types.GET_RMA_DETAIL]({ rma_id: this.$route.query.rma_id })
        .then((res) => {
          const { code, data } = res;

          if (code == 1) {
            this.afterSaleInfo = data;
            const afterSalesFlowArr = utilsOrder.getAfterSalesFlow(
              data.chargeback_type_code || 1
            );
            const currentFlow = afterSalesFlowArr?.find(
              (item) => item.status === data.rma_status_code
            );
            const auditCompleted = utilsOrder.AuditCompleted(
              data.rma_status_code
            );
            this.afterSalesFlow = {
              currentFlow: currentFlow || {},
              flowList: afterSalesFlowArr,
              auditCompleted,
            };
            return res;
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
          captureManualError(err);
        });
    },

    goBack() {
      this.$router.push({
        path: `/myaccount/orderdetail?id=${this.$route.query.id}`,
      });
    },
    goDetail(item) {
      if (!item?.goodsId || !item?.color?.id) {
        return;
      }
      if (Number(item.skc_status) === 0) {
        //skc下架
        return;
      }
      this.$router.push({ path: `/detail/${item.goodsId}-${item.color.id}` });
    },

    copyText(text) {
      utils.copyText(text);
    },
  },
  computed: {
    chargebackReasons() {
      if (!this.afterSaleInfo?.goods) return "";
      const uniqueReasons = Array.from(
        new Set(
          this.afterSaleInfo.goods
            .map((item) => item.chargeback_reason)
            .filter((reason) => reason)
        )
      );
      // 将原因用分号连接
      return uniqueReasons.join("；");
    },

    // 不显示进度条的状态
    noProcessStatus() {
      const noProcessStatusArr = [
        utilsOrder.AfterSalesOrderStatus.AFTERSALE_REFUSED,
        utilsOrder.AfterSalesOrderStatus.AFTERSALE_REFUND_SUCCESS,
        utilsOrder.AfterSalesOrderStatus.refunded,
        utilsOrder.AfterSalesOrderStatus.AFTERSALE_CLOSED,
      ];
      const isNoProcessStatus =
      !noProcessStatusArr.includes(this.afterSaleInfo.rma_status_code) &&
        this.afterSalesFlow.currentFlow &&
        this.afterSalesFlow.flowList.length;
      return isNoProcessStatus;
    },
  },
};
</script>

<style lang="scss" scoped>
.after-sale-detail {
  text-align: left;

  .page-header {
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    margin-bottom: 20px;
    border-bottom: 1px solid #e7e7e7;
    position: relative;

    .icon-back {
      color: #bcbcbc;
      line-height: 40px;
      width: 40px;
      position: absolute;
      top: 0;
      left: 0;
      cursor: pointer;
    }

    .page-title {
      font-size: 13px;
      color: #333333;
      line-height: 40px;
      text-align: center;
    }
  }

  .left {
    display: flex;
    flex-direction: column;
  }

  .after-sale-status {
    padding: 20px;
    display: flex;
    justify-content: flex-start;
    align-content: center;
    gap: 20px;
    background: #fbfbfb;

    .status {
      display: flex;
      align-items: center;
      color: #7f0019;

      .iconfont {
        font-size: 35px;
        margin-right: 20px;
      }
      .label {
        font-size: 20px;
      }
    }
    .description {
      display: flex;
      align-items: center;
      color: #666666;
      font-size: 14px;
      flex: 0 1 80%;

      .udesk-go-service {
        font-size: 14px;
        color: #212322;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  .after-sale-base-info {
    display: flex;
    align-items: center;
    flex-direction: row;
  }

  .iconfont-ot-website {
    cursor: pointer;
  }
  .icon-copy {
    margin-left: 4px;
  }

  .icon-hide {
    margin-left: 10px;
  }

  .after-sale-list {
    padding: 30px 0;
  }

  .after-sale-item,
  .after-sale-list {
    color: #666;
    font-size: 14px;
    padding: 30px 0;
    box-sizing: border-box;

    .after-sale-title {
      font-size: 14px;
      color: #333;
      font-weight: 500;
      margin-bottom: 20px;
    }

    .txt {
      font-size: 12px;
      line-height: 24px;

      a {
        text-decoration: underline;
      }
    }

    .after-sale-content {
      border: none;

      .content-title {
        display: none;
      }

      .content {
        max-height: 330px;
        overflow-y: auto;

        .goods-items {
          & + .goods-items {
            margin-top: 24px;
          }

          .markdown-tip {
            display: flex;
            align-items: center;
            color: #212322;
            font-size: 12px;
            font-weight: 400;
            line-height: 18px;
            margin-top: 8px;

            .iconfont-ot-website {
              margin-right: 2px;
              cursor: pointer;
            }

            &.is-desktop {
              display: none;
            }

            &.is-mobile {
              display: block;
            }
          }
        }

        .goods-items-content {
          display: flex;
          box-sizing: border-box;
          padding: 0;

          .item-img {
            width: 86px;
            height: 86px;
            border-radius: 1px;
            border: 1px solid #dfdfdf;
            margin-right: 8px;
            flex-shrink: 0;
            box-sizing: border-box;
            padding: 2px;
            position: relative;

            .goods-pic {
              // width: 78px;
              width: 100%;
              height: auto;
            }

            .after-sale-status-babel {
              width: 100%;
              position: absolute;
              bottom: 0;
              left: 0;
              background: rgba(0, 0, 0, 0.5);
              color: #fff;
              font-size: 12px;
              text-align: center;
              line-height: 18px;
            }
          }

          .goods-right {
            display: flex;
            flex-direction: column;
          }

          .goods-info {
            display: flex;
            flex-direction: column;
            width: 100%;

            .goods-size {
              display: flex;
              color: #999999;
              font-size: 12px;
            }

            .goods-name {
              font-size: 14px;
              color: #333;
            }
          }

          .goods-others {
            display: flex;
            flex-direction: row-reverse;
            justify-content: space-between;
            align-items: flex-end;
            margin-top: 10px;
            font-size: 12px;
            line-height: 18px;
            color: #000;

            .item-original_price {
              font-weight: 400;
              color: #999;
              text-decoration: line-through;
            }
          }
        }
      }
    }
  }

  .after-sale-item {
    flex: 1;
    border-bottom: 1px solid #d7d8d8;
  }

  // .service-charge {
  //   text-decoration: line-through;
  // }

  .after-sale-others {
    padding-bottom: 30px;

    .total {
      display: flex;
      // justify-content: space-between;
      align-items: center;
      font-size: 14px;
      // width: 100%;

      & + .total {
        margin-top: 8px;
      }
    }

    .tit {
      font-size: 14px;
      line-height: 20px;
      color: #000;
      font-weight: 400;
      min-width: 70px;
    }

    .num {
      font-family: Matter;
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      color: #999999;
    }
  }

  .logistics-bottom {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    gap: 20px;
  }

  .primary {
    background: #7f0019;
    color: #fff;
    border: 1px solid #7f0019;
  }

  .default {
    color: #000000;
    border: 1px solid #000000;
  }

  .after-sales-process {
    position: relative;
    padding: 6px 0 34px;
    width: 94%;
    margin: 20px auto 0px;

    .bg-line {
      background: #eeeeee;
      width: 100%;
      height: 1px;
      border-radius: 100px;
    }

    .process-line {
      position: absolute;
      left: 0;
      top: 6px;
      background: #212322;
      height: 1px;
      border-radius: 100px;
    }

    .level-item {
      position: absolute;
      top: 0;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #bfc0c4;

      &-icon {
        width: 14px;
        height: 14px;
        border-radius: 100px;
        background-color: #bfc0c4;
        position: relative;

        &:after {
          content: "";
          position: absolute;
          width: 8px;
          height: 8px;
          border-radius: 100px;
          // background-color: #fff;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
      }

      &-name {
        font-size: 14px;
        line-height: 20px;
        color: #bfc0c4;
        margin-top: 9px;
        white-space: nowrap;
      }

      &.level-item-active {
        .level-item-icon {
          background-color: #212322;
        }
        .level-item-name {
          color: #333;
        }
      }
      &.current-item {
        top: -4px;
        .iconfont-ot-website {
          background: #fff;
          color: #333;
          font-size: 20px;
        }
        .level-item-name {
          margin-top: 4px;
        }
      }
    }
  }
}

@media only screen and (min-width: 1025px) {
  .after-sale-detail {
    .page-header {
      display: none;
    }

    .after-sale-item,
    .after-sale-list {
      color: #666;
      font-size: 14px;
      padding: 50px 0 30px;
      box-sizing: border-box;

      .after-sale-title {
        font-size: 18px;
        color: #333;
        font-weight: 500;
        margin-bottom: 20px;
      }

      .txt {
        font-size: 14px;
        line-height: 24px;
      }

      & ::v-deep .el-form {
        .el-form-item {
          .el-form-item__content {
            .el-input,
            .el-select {
              width: 200px;
            }
          }
        }
      }

      .save-refund {
        margin-left: 100px;
      }

      .after-sale-content {
        border: 1px solid #d2d2d2;

        .content-title {
          height: 40px;
          color: #333;
          font-size: 14px;
          line-height: 40px;
          border-bottom: 1px solid #d2d2d2;
          margin-bottom: 20px;
          padding-left: 30px;
          display: block;
        }

        .content {
          max-height: 330px;
          overflow-y: auto;

          .goods-items {
            .markdown-tip {
              display: flex;
              align-items: center;
              color: #212322;
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              margin-top: 6px;

              .iconfont-ot-website {
                margin-right: 2px;
              }

              &.is-desktop {
                display: block;
              }

              &.is-mobile {
                display: none;
              }
            }
          }

          .goods-items-content {
            display: flex;
            box-sizing: border-box;
            margin-bottom: 20px;
            padding: 0 30px;

            .item-img {
              width: 70px;
              height: 70px;
              border-radius: 1px;
              border: 1px solid #dfdfdf;
              margin-right: 20px;
              flex-shrink: 0;
              box-sizing: border-box;
              padding: 2px;

              .goods-pic {
                width: 64px;
                height: 64px;
              }
            }

            .goods-right {
              display: flex;
              flex-direction: row;
              flex-grow: 1;

              .goods-info {
                display: flex;
                flex-direction: column;
                width: 60%;

                .goods-size {
                  display: flex;
                  color: #999999;
                  font-size: 14px;
                }

                .goods-name {
                  font-size: 14px;
                  color: #333;
                }
              }

              .goods-others {
                width: 40%;
                align-self: flex-start;
                margin-top: 0;
                font-size: 14px;
                line-height: 20px;
              }
            }
          }
        }
      }
    }

    .after-sale-others {
      .total {
        .num {
          // font-size: 18px;
          line-height: 28px;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .after-sale-detail {
    .bread-crumbs {
      display: none;
    }

    .page-header {
      display: block;
    }

    .after-sale-status {
      flex-direction: column;
      gap: 10px;

      .status {
        .iconfont {
          margin-right: 16px;
        }
        .label {
          font-size: 14px;
        }
      }
      .description {
        font-size: 12px;
        .udesk-go-service {
          font-size: 12px;
          color: #212322;
        }
      }
    }

    .after-sale-base-info {
      flex-direction: column;

      .after-sale-item {
        width: 100%;
      }
    }

    .icon-hide {
      float: right;
    }

    .logistics-bottom {
      justify-content: flex-end;
      border-top: 1px solid rgba(211, 211, 213, 1);
      padding-top: 12px;
      gap: 10px;
    }

    .after-sales-process {
      width: 80%;
    }
  }
  .after-sale-others {
      .total {
        justify-content: space-between;
        .num {
          // font-size: 18px;
          line-height: 28px;
        }
      }
    }
}

@media only screen and (max-width: 480px) {
  .goods-items {
    .markdown-tip {
      display: flex;
      align-items: center;
      color: #212322;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      margin-top: 6px;

      .iconfont-ot-website {
        margin-right: 2px;
      }

      &.is-mobile {
        display: none;
      }
    }
  }
}
</style>
